
export default {

    setCount(state, count) {
      state.count = count
    },

    setCurrentEcheancier (state, echeancier) {
      state.current = echeancier
    },

    setEcheanciers (state, echeanciers) {
      state.all = echeanciers
      state.initialized = true
      state.page = 1
    },

    setNextEcheanciers (state, echeanciers) {    
      state.all = [ ...state.all, ...echeanciers ]
      state.page++
    }
}